<h1>Products</h1>
<nav mat-tab-nav-bar [tabPanel]="tabs">
  @for (link of links; track link) {
    <a
      mat-tab-link
      (click)="gotoTab(link)"
      [active]="activeLink == link"
      >{{ link.title }}</a
      >
    }
  </nav>
  @if (activeLink.title === 'Stripe Products') {
    <app-vendor-products-stripe-products
    ></app-vendor-products-stripe-products>
  }
  @if (activeLink.title === 'Vendor Products') {
    <app-vendor-products-product-list
    ></app-vendor-products-product-list>
  }
  @if (activeLink.title === 'User Vendor Products') {
    <app-vendor-products-user-products
    ></app-vendor-products-user-products>
  }
  @if (activeLink.title === 'Vendor Webhook Events') {
    <app-vendor-products-webhooks
    ></app-vendor-products-webhooks>
  }
  @if (activeLink.title === 'Vendor API Log') {
    <app-vendor-products-api-log
    ></app-vendor-products-api-log>
  }
  @if (activeLink.title === 'Vendor Pending Transfers') {
    <app-vendor-pending-transfers-page
    ></app-vendor-pending-transfers-page>
  }
  @if (activeLink.title === 'Vendor Completed Transfers') {
    <app-vendor-completed-transfers-page
    ></app-vendor-completed-transfers-page>
  }
  <mat-tab-nav-panel #tabs></mat-tab-nav-panel>
